import {teamMembers} from "data/TeamMembers";
import TeamCard from "pages/Consultancy/components/Team/TeamCard";
import React from "react";

const TeamList = () => {
    return (
        <section className='profile-section'>
            <div className="container">
                <div className="profile" data-aos="fade-down" data-aos-duration-="2000">
                    <h1>Our Team</h1>
                    <h4 className='mb-5 fw-bold offering-title'>Meet the experts who will provide personalized guidance
                        tailored to your goals.</h4>
                </div>

                <div className="all-experts row">

                    {teamMembers.map((member) => (
                        <TeamCard
                            key={member.id}
                            id={member.id}
                            name={member.name}
                            image={member.image}
                            details={member.details}
                        />
                    ))}

                </div>
            </div>
        </section>
    )
}

export default TeamList;
